/**
 * Script para gerenciar os filtros ativos na página de seminovos
 * 
 * @package MF_Concessionarias_2025
 */

document.addEventListener('DOMContentLoaded', function() {
    // Elementos do DOM
    const filtrosAtivosContainer = document.getElementById('filtros-ativos');
    const filtrosAtivosList = document.getElementById('filtros-ativos-lista');
    const limparFiltrosBtn = document.getElementById('limpar-filtros');
    
    // Estado dos filtros
    let filtrosAtivos = {};
    
    /**
     * Inicializa os filtros a partir da URL
     */
    function inicializarFiltrosDeURL() {
        const urlParams = new URLSearchParams(window.location.search);
        let temFiltros = false;
        
        // Parâmetros comuns de filtros
        const filtrosParams = [
            { param: 'categoria', label: 'Categoria' },
            { param: 'marca', label: 'Marca' },
            { param: 'modelo', label: 'Modelo' },
            { param: 'ano', label: 'Ano' },
            { param: 'estado', label: 'Estado' },
            { param: 'localizacao', label: 'Localização' }
        ];
        
        // Función para obtener nombre de categoría desde el DOM o sessionStorage
        function obterNomeCategoria(id) {
            // Primero intentar desde los checkboxes en el DOM
            const checkbox = document.querySelector(`.filtro-categoria-checkbox[data-categoria="${id}"]`);
            if (checkbox) {
                const nome = checkbox.getAttribute('data-categoria-nome');
                if (nome) return nome;
            }
            
            // Fallback a sessionStorage
            try {
                const categoriasMapStr = sessionStorage.getItem('categoriasNomes');
                if (categoriasMapStr) {
                    const categoriasMap = JSON.parse(categoriasMapStr);
                    if (categoriasMap[id]) return categoriasMap[id];
                }
            } catch (e) {
                console.error('Erro ao obter mapa de categorias:', e);
            }
            
            // Retornar el ID si no se encuentra el nombre
            return id;
        }
        
        // Intentar obtener el mapa de estados del sessionStorage
        let estadosMap = {};
        try {
            const estadosMapStr = sessionStorage.getItem('estadosNomesCompletos');
            if (estadosMapStr) {
                estadosMap = JSON.parse(estadosMapStr);
            }
        } catch (e) {
            console.error('Erro ao obter mapa de estados:', e);
        }

        // Intentar obtener el mapa de categorías (id => nombre) del sessionStorage
        let categoriasMap = {};
        try {
            const categoriasMapStr = sessionStorage.getItem('categoriasNomes');
            if (categoriasMapStr) {
                categoriasMap = JSON.parse(categoriasMapStr);
            }
        } catch (e) {
            console.error('Erro ao obter mapa de categorias:', e);
        }
        
        filtrosParams.forEach(filtro => {
            if (urlParams.has(filtro.param)) {
                const valor = urlParams.get(filtro.param);
                if (valor) {
                    // Valor decodificado de la URL
                    const valorDecodificado = decodeURIComponent(valor);
                    
                    // Si es un estado, intentar usar el nombre completo
                    if (filtro.param === 'estado') {
                        // Si hay múltiples estados (separados por coma)
                        if (valorDecodificado.includes(',')) {
                            const siglas = valorDecodificado.split(',');
                            const nombresCompletos = siglas.map(sigla => estadosMap[sigla] || sigla);
                            
                            filtrosAtivos[filtro.param] = {
                                label: filtro.label,
                                valor: nombresCompletos.join(', '),
                                valoresOriginales: valorDecodificado
                            };
                        } else {
                            // Si es un solo estado
                            const nombreCompleto = estadosMap[valorDecodificado] || valorDecodificado;
                            
                            filtrosAtivos[filtro.param] = {
                                label: filtro.label,
                                valor: nombreCompleto,
                                valoresOriginales: valorDecodificado
                            };
                        }
                    } else if (filtro.param === 'categoria') {
                        // Mapear IDs de categorías a nombres usando DOM o sessionStorage
                        if (valorDecodificado.includes(',')) {
                            const ids = valorDecodificado.split(',');
                            const nomes = ids.map(id => obterNomeCategoria(id));
                            filtrosAtivos[filtro.param] = {
                                label: filtro.label,
                                valor: nomes.join(', '),
                                valoresOriginales: valorDecodificado
                            };
                        } else {
                            const nome = obterNomeCategoria(valorDecodificado);
                            filtrosAtivos[filtro.param] = {
                                label: filtro.label,
                                valor: nome,
                                valoresOriginales: valorDecodificado
                            };
                        }
                    } else {
                        // Para otros filtros que no son estados ni categoria
                        filtrosAtivos[filtro.param] = {
                            label: filtro.label,
                            valor: valorDecodificado
                        };
                    }
                    
                    temFiltros = true;
                }
            }
        });
        
        // Atualizar a interface se houver filtros
        if (temFiltros) {
            atualizarFiltrosAtivos();
        }
    }
    
    /**
     * Atualiza a lista de filtros ativos na interface
     */
    function atualizarFiltrosAtivos() {
        // Limpar lista atual
        filtrosAtivosList.innerHTML = '';
        
        // Verificar se há filtros ativos
        if (Object.keys(filtrosAtivos).length > 0) {
            // Mostrar o container
            filtrosAtivosContainer.classList.remove('hidden');
            
            // Adicionar cada filtro à lista
            Object.entries(filtrosAtivos).forEach(([key, filtro]) => {
                const filtroElement = document.createElement('div');
                filtroElement.className = 'flex items-start text-secondary text-texto-normal font-normal mb-3';
                
                // Separar los valores si hay múltiples (separados por coma)
                const valores = filtro.valor.split(', ');
                
                if (valores.length > 1) {
                    // Si hay múltiples valores, crear un botón para cada uno
                    // Cambiar a flex-col para que los elementos aparezcan uno debajo del otro
                    filtroElement.className += ' flex-col gap-2';
                    let htmlContent = ``;
                    
                    valores.forEach((valor, index) => {
                        htmlContent += `
                            <span class="inline-flex items-center justify-between w-full bg-soft-gray rounded-2xl border border-secondary-100 p-4 mb-2">
                                <span>${valor}</span>
                                <button class="ml-1 remove-valor-filtro" data-filtro="${key}" data-valor="${valor}">
                                    <i class="bi bi-x text-secondary text-texto-normal font-normal"></i>
                                </button>
                            </span>
                        `;
                    });
                    
                    filtroElement.innerHTML = htmlContent;
                } else {
                    // Si es un solo valor, mantener el formato original pero con el valor como botón
                    filtroElement.innerHTML = `
                        <span class="inline-flex items-center justify-between w-full bg-soft-gray rounded-2xl border border-secondary-100 p-4">
                            <span>${filtro.valor}</span>
                            <button class="ml-2 remove-filtro" data-filtro="${key}">
                                <i class="bi bi-x text-secondary text-texto-normal font-normal"></i>
                            </button>
                        </span>
                    `;
                }
                filtrosAtivosList.appendChild(filtroElement);
                
                // Adicionar evento para remover o filtro (botón general)
                const removeBtn = filtroElement.querySelector('.remove-filtro');
                if (removeBtn) {
                    removeBtn.addEventListener('click', function() {
                        removerFiltro(key);
                    });
                }
                
                // Adicionar eventos para remover valores individuales
                const removeBtnsValores = filtroElement.querySelectorAll('.remove-valor-filtro');
                removeBtnsValores.forEach(btn => {
                    btn.addEventListener('click', function() {
                        const filtro = this.getAttribute('data-filtro');
                        const valor = this.getAttribute('data-valor');
                        removerValorFiltro(filtro, valor);
                    });
                });
            });
        } else {
            filtrosAtivosContainer.classList.add('hidden');
        }
    }
    
    /**
     * Remove um filtro específico e atualiza a URL e a interface
     */
    function removerFiltro(filtroKey) {
        // Remover do objeto de filtros
        delete filtrosAtivos[filtroKey];
        
        // Atualizar URL
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete(filtroKey);
        
        // Atualizar a interface e recarregar a página com os novos parâmetros
        atualizarURL(urlParams);
    }
    
    /**
     * Remove um valor específico de um filtro e atualiza a URL e a interface
     */
    function removerValorFiltro(filtroKey, valorParaRemover) {
        if (filtrosAtivos[filtroKey]) {
            // Obter os valores atuais mostrados (nombres completos)
            const valoresAtuais = filtrosAtivos[filtroKey].valor.split(', ');
            
            // Obter os valores originais (siglas)
            let valoresOriginais = [];
            if (filtrosAtivos[filtroKey].valoresOriginales) {
                valoresOriginais = filtrosAtivos[filtroKey].valoresOriginales.split(',');
            }
            
            // Encontrar o índice do valor a ser removido
            const indiceParaRemover = valoresAtuais.indexOf(valorParaRemover);
            
            // Remover o valor específico dos valores mostrados
            const novosValoresMostrados = valoresAtuais.filter((_, index) => index !== indiceParaRemover);
            
            // Remover o valor correspondente dos valores originais
            let novosValoresOriginais = valoresOriginais;
            if (indiceParaRemover !== -1 && valoresOriginais.length > indiceParaRemover) {
                novosValoresOriginais = valoresOriginais.filter((_, index) => index !== indiceParaRemover);
            }
            
            // Atualizar URL
            const urlParams = new URLSearchParams(window.location.search);
            
            if (novosValoresMostrados.length > 0) {
                // Se ainda há valores, atualizar o filtro
                filtrosAtivos[filtroKey].valor = novosValoresMostrados.join(', ');
                filtrosAtivos[filtroKey].valoresOriginales = novosValoresOriginais.join(',');
                
                // Usar os valores originais (siglas) para a URL
                urlParams.set(filtroKey, novosValoresOriginais.join(','));
            } else {
                // Se não há mais valores, remover o filtro completamente
                delete filtrosAtivos[filtroKey];
                urlParams.delete(filtroKey);
            }
            
            // Atualizar a interface e recarregar a página com os novos parâmetros
            atualizarURL(urlParams);
        }
    }
    
    /**
     * Limpa todos os filtros
     */
    function limparTodosFiltros() {
        filtrosAtivos = {};
        atualizarURL(new URLSearchParams());
    }
    
    /**
     * Atualiza a URL e recarrega a página
     */
    function atualizarURL(urlParams) {
        const newURL = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
        window.location.href = newURL;
    }
    
    /**
     * Adiciona eventos aos elementos da interface
     */
    function adicionarEventListeners() {
        // Evento para limpar todos os filtros
        if (limparFiltrosBtn) {
            limparFiltrosBtn.addEventListener('click', limparTodosFiltros);
        }
        
        // Eventos para os filtros
        document.addEventListener('filtroSeminovosChanged', function(e) {
            if (e.detail && e.detail.filtro && e.detail.valor) {
                const { filtro, label, valor, valoresOriginales } = e.detail;
                
                // Adicionar ou atualizar filtro
                filtrosAtivos[filtro] = { 
                    label, 
                    valor,
                    valoresOriginales // Guardar los valores originales (siglas) para la URL
                };
                
                // Si es un estado, intentar obtener los nombres completos del sessionStorage
                if (filtro === 'estado' && !valor.includes(', ')) {
                    try {
                        // Intentar obtener el mapa de estados del sessionStorage
                        const estadosMapStr = sessionStorage.getItem('estadosNomesCompletos');
                        if (estadosMapStr) {
                            const estadosMap = JSON.parse(estadosMapStr);
                            // Si existe el estado en el mapa, usar el nombre completo
                            if (estadosMap[valor]) {
                                filtrosAtivos[filtro].valor = estadosMap[valor];
                            }
                        }
                    } catch (e) {
                        console.error('Erro ao obter mapa de estados:', e);
                    }
                }
                
                // Atualizar URL
                const urlParams = new URLSearchParams(window.location.search);
                // Usar los valores originales para la URL (siglas)
                if (valoresOriginales) {
                    urlParams.set(filtro, valoresOriginales);
                } else {
                    urlParams.set(filtro, valor);
                }
                
                // Atualizar a interface
                atualizarFiltrosAtivos();
            }
        });
        
        // Evento para remover filtros quando se desmarcam todos os checkboxes
        document.addEventListener('filtroSeminovosRemoved', function(e) {
            if (e.detail && e.detail.filtro) {
                const filtroKey = e.detail.filtro;
                
                // Remover do objeto de filtros
                if (filtrosAtivos[filtroKey]) {
                    delete filtrosAtivos[filtroKey];
                }
                
                // Atualizar URL sem recarregar a página
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.delete(filtroKey);
                
                const newURL = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                history.pushState({}, '', newURL);
                
                // Atualizar a interface
                atualizarFiltrosAtivos();
                
                // Atualizar a lista de produtos via AJAX
                if (typeof window.atualizarProdutosPorAjax === 'function') {
                    window.atualizarProdutosPorAjax();
                }
            }
        });
    }
    
    // Inicializar
    inicializarFiltrosDeURL();
    adicionarEventListeners();
});
